import React from 'react';
import { SvgIcon } from '@material-ui/core';

export const DeliveryIcon = (props) => (
  <SvgIcon width="108" height="50" viewBox="0 0 108 50" {...props}>
    <g id="Icon_Livraison" transform="translate(0 -19.365)">
      <path
        id="Union_1"
        data-name="Union 1"
        className="cls-1"
        d="M58.657,31.07A6.142,6.142,0,1,1,64.8,37.156,6.121,6.121,0,0,1,58.657,31.07Zm2.068,0A4.072,4.072,0,1,0,64.8,27.038,4.061,4.061,0,0,0,60.725,31.07Zm-33.994,0a6.138,6.138,0,1,1,6.14,6.087A6.117,6.117,0,0,1,26.732,31.07Zm2.065,0a4.073,4.073,0,1,0,4.075-4.032A4.061,4.061,0,0,0,28.8,31.07ZM73.39,32.744A1.027,1.027,0,0,1,72.5,31.59l1.931-14.014a.5.5,0,0,0-.458-.477l-4.7-.508a1.029,1.029,0,0,1-.8-.552l-4.063-7.81H54.2V27.2a1,1,0,0,1-.343.743,1.021,1.021,0,0,1-.948.64H40.24a1.024,1.024,0,1,1,0-2.048H51.872V2.045h-30.2V26.538h3.308a1.024,1.024,0,1,1,0,2.048H20.64A1.03,1.03,0,0,1,19.6,27.562V1.025A1.031,1.031,0,0,1,20.64,0H52.907a1.028,1.028,0,0,1,1.035,1.025V6.18h11.1a1.031,1.031,0,0,1,.92.554l4.1,7.878,4.145.449A2.559,2.559,0,0,1,76.5,17.776l0,.015-1.937,14.08a1.036,1.036,0,0,1-1.027.885A.871.871,0,0,1,73.39,32.744ZM42,32.756a1.025,1.025,0,1,1,0-2.05H56.086a1.025,1.025,0,1,1,0,2.05ZM1.033,22.61a1.025,1.025,0,1,1,0-2.05H15.119a1.025,1.025,0,1,1,0,2.05Zm5.123-5.072a1.025,1.025,0,1,1,0-2.05h8.963a1.025,1.025,0,1,1,0,2.05ZM57.974,17.1a1.034,1.034,0,0,1-1.035-1.025V11.537a1.034,1.034,0,0,1,1.035-1.025h4.055a1.03,1.03,0,0,1,.924.568l2.278,4.545a1.014,1.014,0,0,1-.051.994,1.04,1.04,0,0,1-.876.485Zm1.035-2.05h3.625l-1.248-2.492H59.008ZM11.277,12.465a1.025,1.025,0,1,1,0-2.05h3.842a1.025,1.025,0,1,1,0,2.05Z"
        transform="translate(15.998 25.365)"
        fill="#eee"
      />
      <rect
        id="Rectangle_1954"
        data-name="Rectangle 1954"
        className="cls-2"
        width="108"
        height="50"
        transform="translate(0 19.365)"
        fill="none"
      />
    </g>
  </SvgIcon>
);

export default DeliveryIcon;
